module.exports = __webpack_public_path__ + "img/noimg-en.a38d0e4a.jpg";